var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user && !_vm.user.exists() && !_vm.$vuetify.breakpoint.xs)?_c('div',[_c('v-btn',{staticClass:"text-none tit rounded-lg",attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.goToSignIn()}}},[_vm._v(" Iniciar sessió ")])],1):_c('user-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }